import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
});

if (process.env.ENV === "stage" && typeof window === "undefined") {
  apiClient.interceptors.request.use((config) => {
    const headerName = process.env.SERVER_TEST_HEADER_NAME ?? "";
    const headerValue = process.env.SERVER_TEST_HEADER_VALUE ?? "";

    if (headerName && headerValue) {
      config.headers[headerName] = headerValue;
    } else {
      console.warn("WARN:: Server test headers are not set correctly");
    }
    return config;
  });
}

export default apiClient;
